/* Mosaic Paint – the phone / tablet layout, installing the app and offline support (shared with the raster app). */
import { MZ } from '../core/api.ts';
import { initShell } from '../shared/shell.ts';

initShell(MZ.stage);
